module.exports = __webpack_public_path__ + "static/media/ME_idle_anim.2696b09d.gif";